module.exports = __webpack_public_path__ + "static/media/Security.cfe51ad6.svg";